import React, { useState, useCallback, useRef, useEffect } from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'

const TextEditableComponent = ({
    text,
    onChange = () => {},
    editable = true,
    onTab = () => {}
}) => {

    const [editing, setEditing] = useState(false)
    const inputRef = useRef(null)

    const finish = (skipChange = false) => {
        setEditing(false)
        if (!skipChange && inputRef.current) {
            const newValue = inputRef.current.value
            if (newValue !== text) {
                onChange(newValue)
            }
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Tab") {
            e.preventDefault()
            finish(false)
            onTab()
        }

        if (e.key === "Enter") {
            e.preventDefault()
            finish(false)
        }

        if (e.key === "Escape") {
            e.preventDefault()
            finish(true)
        }
    }

    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current.focus()
            inputRef.current.select()
        }
    }, [editing])

    if (editing)
        return (
            <ClickAwayListener onClickAway={() => finish(false)}>
                <input
                    type="text"
                    ref={inputRef}
                    defaultValue={text}
                    onKeyDown={handleKeyDown}
                    style={{ width: "100%" }}
                />
            </ClickAwayListener>
        )

    return (
        <div
            onDoubleClick={() => editable && setEditing(true)}
            data-editable-cell="true"
        >
            {text}
        </div>
    )
}


export default TextEditableComponent
